<div class="container">
  <div class="left">
    <button
      mat-icon-button
      (click)="cancel()"
      matTooltip="Cancelar"
      matTooltipClass="forward-message-tooltip"
    >
      <mat-icon class="icon">close</mat-icon>
    </button>
    <div class="message-status">
      {{ forwardMessages.length | i18nPlural : messageMapping }}
    </div>
  </div>

  <button
    mat-icon-button
    matTooltip="Encaminhar"
    matTooltipClass="forward-message-tooltip"
    class="rotate-180"
    [ngClass]="{ 'opacity-05': !forwardMessages.length && idChannel }"
    (click)="selectChannel()"
    [disabled]="!forwardMessages.length && idChannel"
  >
    <mat-icon class="icon material-icons-outlined">reply</mat-icon>
  </button>
</div>
